export const Modal = (() => {
	const getYTVideoID = (url) => {
		const urlParams = new URLSearchParams(new URL(url).search);
		return urlParams.get("v");
	};

	const showModal = (trigger) => {
		const modalTrigger = trigger.getAttribute("data-modal-trigger");
		const modal = document.querySelector(`[data-modal="${modalTrigger}"]`);

		if (!modal) return;

		if (modal.classList.contains("modal--video") && !modal.classList.contains("is-visible")) {
			const videoUrl = trigger.dataset.videoUrl;
			videoAsContent(videoUrl, modal);
		}

		modal.classList.add("is-visible");
	};

	const closeModal = () => {
		document.querySelectorAll(".modal.is-visible").forEach((modal) => {
			const modalIframe = modal.querySelector("iframe");

			if (modalIframe) {
				setTimeout(() => {
					modalIframe.remove();
				}, 300);
			}

			modal.classList.remove("is-visible");
		});
	};

	const videoAsContent = (videoUrl, modal) => {
		if (!videoUrl) return;

		const videoID = getYTVideoID(videoUrl);
		const iframe = document.createElement("iframe");

		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
		iframe.setAttribute("allowfullscreen", true);
		iframe.setAttribute("src", `https://www.youtube-nocookie.com/embed/${videoID}?autoplay=1&playlist=${videoID}&mute=1&loop=1&color=white&playsinline=1&rel=0&enablejsapi=1&iv_load_policy=3&fs=0&cc_load_policy=0`);

		modal.querySelector(".modal__content").prepend(iframe);
	};

	const bindClose = () => {
		document.querySelectorAll(".js-close-modal").forEach((closeBtn) => {
			closeBtn.addEventListener("click", (e) => {
				e.preventDefault();
				closeModal();
			});
		});

		document.addEventListener("mouseup", (e) => {
			if (!e.target.closest(".modal__dialog")) {
				closeModal();
			}
		});

		document.addEventListener("keydown", (e) => {
			if (e.code === "Escape") {
				closeModal();
			}
		});
	};

	const init = () => {
		const params = new URLSearchParams(window.location.search);
		const showModalInURL = params.get("show_popin");

		document.querySelectorAll("[data-modal-trigger]").forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				e.preventDefault();
				showModal(trigger);
			});
		});

		if (showModalInURL) {
			document.querySelectorAll(`[data-modal="${showModalInURL}"]`).forEach((trigger) => {
				showModal(trigger);
			});
		}

		bindClose();
	};

	return {
		init,
	};
})();
